export { default as EventInfo } from "./EventInfo";
